import { jsx } from "react/jsx-runtime";
import { useRicosTheme, RicosViewer } from "@wix/form-fields";
import { DATA_HOOKS } from "../../tpa/widget/data-hooks.js";
import styles from "./submit-status-message.module.scss";
const thankYouMessageCustomStyles = {
  p: {
    fontSize: "var(--wix-forms-formThankYouMessageFont-size, var(--wix-forms-formParagraphFont-size))",
    fontFamily: "var(--wix-forms-formThankYouMessageFont-family, var(--wix-forms-formParagraphFont-family))",
    color: "rgb(var(--wix-forms-formThankYouMessageColor, var(--wix-forms-formParagraphColor)))"
  }
};
const RICOS_THEME = {
  customStyles: thankYouMessageCustomStyles
};
const SubmitThankYouMessage = ({
  messageText
}) => {
  const customTheme = useRicosTheme(RICOS_THEME);
  if (!messageText) {
    return null;
  }
  return /* @__PURE__ */ jsx(
    RicosViewer,
    {
      dataHook: DATA_HOOKS.SUBMIT_THANK_YOU_MESSAGE,
      content: messageText,
      customTheme,
      className: styles.thankYouMessage
    }
  );
};
export {
  SubmitThankYouMessage
};
//# sourceMappingURL=submit-thank-you-message.js.map
